module.exports = {
      id: "pre-blue-present-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-present",
      toString: function () {
        return this.url;
      }
    }